<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.${$constant.table.EVENT_HEADER_KEY.startDate}`]="{ item }">
                {{ $util.getDDMMYYYYDateFormat(item[$constant.table.EVENT_HEADER_KEY.startDate]) }}
            </template>

            <template v-slot:[`item.${$constant.table.EVENT_HEADER_KEY.status}`]="{ item }">
                <button-status-field
                    disableClick
                    hideIcon
                    :status="item[$constant.table.EVENT_HEADER_KEY.status]"/>
            </template>

            <template v-slot:[`item.${$constant.table.EVENT_HEADER_KEY.member}`]="{ item }">
                <div class="d-flex justify-start align-center">
                    <icon
                        class="black--text"
                        value="groups"/>
                    <div>
                        &ensp; {{ `${item[$constant.table.EVENT_HEADER_KEY.member].amount}/${item[$constant.table.EVENT_HEADER_KEY.member].max}` }}
                    </div>
                </div>
            </template>

            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('viewAward', item)">
                    <icon
                        value="emoji_events"
                        size="18px"/>
                </div>
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('viewQr', item)">
                    <icon
                        value="hero_Qrcode"
                        size="18px"/>
                </div>
                <div class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                     @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'
import ButtonStatusField from '@/components/fields/ButtonStatusField'

export default {
    name: 'EventTable',

    components: {
        BaseTable,
        ButtonStatusField
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('eventList.table.header.startDate'),
                    value: this.$constant.table.EVENT_HEADER_KEY.startDate,
                    width: '140px'
                },
                {
                    text: this.$t('eventList.table.header.customerName'),
                    value: this.$constant.table.EVENT_HEADER_KEY.customerName,
                    sortable: false
                },
                {
                    text: this.$t('eventList.table.header.member'),
                    value: this.$constant.table.EVENT_HEADER_KEY.member,
                    sortable: false,
                    width: '120px'
                },
                {
                    text: this.$t('eventList.table.header.status'),
                    value: this.$constant.table.EVENT_HEADER_KEY.status,
                    sortable: false,
                    align: 'center',
                    width: '160px'
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    width: '140px'
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items.map(item => ({
                ...item,
                customerName: item.customer,
                member: {
                    amount: item.participantAmount,
                    max: item.participantMax
                }
            }))
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
